import {
  WORK_TYPE,
} from "./context";

export const DEFAULT_ECOSYSTEM = {
  id: "ad63a367-a5e5-47b6-a9bf-0a6dfb5fe1ff",
  name: "Java",
  icon_url: ""
};


export const workTypeOptions = [
  { value: WORK_TYPE.REMOTE, label: "private-home-page:filterForm.acceptRemoteWork" },
  { value: WORK_TYPE.PRESENTIAL, label: "private-home-page:filterForm.acceptPresentialWork" },
  { value: WORK_TYPE.HYBRID, label: "private-home-page:filterForm.acceptHybridWork" },
];

